import { API_ENDPOINTS } from '@/utils/constants/end-points';

import apiClient from '../api-client';
import { RegionItem } from '../types';

interface ClientListParams {
  page?: number;
  limit?: number;
  sortDirection: 'asc' | 'desc';
  sortColumn: string;
  search: string;
  statusCode: string;
  country: string;
  isExport?: boolean;
}

export const getClientUserList = async ({
  page,
  limit,
  search,
  sortColumn,
  sortDirection,
  statusCode,
  country,
  isExport,
}: ClientListParams) => {
  const params: Record<string, any> = {};
  if (isExport) {
    params.isExport = true;
  } else {
    if (page !== undefined) params.offset = page;
    if (limit !== undefined) params.limit = limit;
  }
  if (search) params.searchField = search;
  if (sortColumn) params.sortBy = sortColumn;
  if (sortDirection) params.sortDir = sortDirection;
  if (statusCode) params.status = statusCode;
  if (country) params.country = country;

  const queryString = new URLSearchParams(params).toString();
  const url = `${API_ENDPOINTS?.ONBOARDING}?${queryString}`;

  const res = await apiClient.get(url);
  return res?.data?.data;
};

export const fetchClientUserById = async (clientId: string) => {
  const res = await apiClient.get(`${API_ENDPOINTS?.ONBOARDING}/${clientId}`);
  return res?.data?.data;
};

export const postFileUpload = async (file: File, type: string) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await apiClient.post(
    `/AwardManagement/fileUpload?type=${type}`,
    formData,
    {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return res?.data?.data;
};

export const deleteFileApi = async (key: string) => {
  const res = await apiClient.delete(`/AdminManagement/fileUpload?key=${key}`);
  return res?.data;
};

export const createClientUser = async (payload: FormData) => {
  const res = await apiClient.post(`${API_ENDPOINTS?.ONBOARDING}`, payload, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'multipart/form-data',
    },
  });
  return res?.data;
};

export const updateClientUser = async (payload: FormData, clientId: string) => {
  const res = await apiClient.put(
    `${API_ENDPOINTS?.ONBOARDING}/${clientId}`,
    payload,
    {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res?.data;
};

// Sends the target status rather than relying on the endpoint to toggle, so a
// retry or a stale list converges on the value the admin chose.
export const updateClientUserStatus = async (
  clientId: string,
  status: number
) => {
  const res = await apiClient.put(
    `${API_ENDPOINTS?.ONBOARDING}/status/${clientId}`,
    { status }
  );
  return res?.data;
};

export const retryClientProvisioning = async (clientId: string) => {
  const res = await apiClient.post(
    `${API_ENDPOINTS?.ONBOARDING}/retry/${clientId}`
  );
  return res?.data;
};

// Region API
export const fetchRegions = async (): Promise<RegionItem[]> => {
  const res = await apiClient.get(`${API_ENDPOINTS.ONBOARDING}/regions`);
  return res?.data?.data ?? [];
};

export const fetchDNSRecords = async (clientId: string) => {
  const res = await apiClient.get(
    `${API_ENDPOINTS.ONBOARDING}/${clientId}/dns-records`
  );
  return res?.data?.data;
};

export const verifyDNSRecords = async (clientId: string) => {
  const res = await apiClient.post(
    `${API_ENDPOINTS.ONBOARDING}/${clientId}/dns-validate`
  );
  return res?.data;
};
